export const CtrlTwrShipmentFileUploadsDataElements = [
    {
        dBKey: 'ProRef',
        displayName: 'PRO',
        primaryCol: true,
        mobileDisplay: true,
        sortable: true,
        colWidth: 150
    },
    {
        dBKey: 'FileName',
        displayName: 'File Name',
        primaryCol: false,
        mobileDisplay: false,
        sortable: true,
        colWidth: 300
    },
    {
        dBKey: 'UploadDT',
        displayName: 'Upload Date',
        primaryCol: false,
        mobileDisplay: false,
        sortable: true,
        colWidth: 250
    },
    {
        dBKey: 'EmailAddr',
        displayName: 'Uploaded By User',
        primaryCol: false,
        mobileDisplay: false,
        sortable: true,
        colWidth: 300
    },
]


export default CtrlTwrShipmentFileUploadsDataElements

